import { render, staticRenderFns } from "./LearnEnglishP.vue?vue&type=template&id=2a1ee7f3&scoped=true&"
import script from "./LearnEnglishP.vue?vue&type=script&lang=js&"
export * from "./LearnEnglishP.vue?vue&type=script&lang=js&"
import style0 from "./LearnEnglishP.vue?vue&type=style&index=0&id=2a1ee7f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1ee7f3",
  null
  
)

export default component.exports